<template>
  <div class="card pt-sm-10 pb-sm-15 pa-0">
    <div class="card__title px-4 px-sm-12 mb-sm-10 mb-10">{{title}}</div>
    <div class="card__body  px-sm-15 px-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style lang="scss" scoped>
.card {
  background: #ffffff;
  margin: 0 auto;
  max-width: 480px;
  box-shadow: 0px 4px 14px rgba(34, 39, 51, 0.05);
  border-radius: 6px;

  &__title {
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #141e4e;    
  }
}
</style>
